import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
export async function getControls() {
 
    try {
      const response = await authService.apiCall(`${BASE_URL}/controls/get`, {
        method: 'GET',
     
      });

      if (!response.ok) {
        throw new Error('Failed to get controls');
      }

      const result = await response.json();
      //console.log('Controls fetched successfully:', result);
      // Optionally, navigate to another page or show a success message
    } catch (error) {
        console.error('Error fetching controls:', error);
      // Optionally, show an error message to the user
    }
};

export async function getControl(id:any){
  try{
    const response = await authService.apiCall(`${BASE_URL}/controls/${id}`, {
        method: 'GET',
       
      });

     

      if (!response.ok) {
        throw new Error('Failed to get control');
      }


      const result = await response.json();
      return result;
  }
  catch(error:any){
    console.error('Error fetching controls:', error);
    throw new Error(error);
  }
}

// Re-export fetchDataApi from question service for compatibility
export { fetchDataApi } from './question';